import React from 'react';
import { CustomerQueueItem } from './customer-queue-item';
import { CustomerQueue } from '../../../types/models/customer-queue';

interface CustomerQueuesProps {
  queues: Array<CustomerQueue>;
}

export function CustomerQueues(props: CustomerQueuesProps) {
  return (
    <>
      {props.queues.map((q) => (
        <a key={q.id} className="ui label" href={`/admin/providers/${q.serviceProviderId}`}>
          <CustomerQueueItem key={q.id} queue={q} />
        </a>
      ))}
    </>
  );
}
